export * from './NftDetail';
